import imagesLoaded from 'imagesloaded';
import InfiniteScroll from 'infinite-scroll';
import Masonry from 'masonry-layout';

// Make imagesLoaded available for InfiniteScroll
InfiniteScroll.imagesLoaded = imagesLoaded;

/**
 * Gallery box masonry
 */
var galleryGrid = document.querySelector('.js-masonry-gallery');
if (galleryGrid) {
  imagesLoaded(galleryGrid, function () {
    var galleryMsnry = new Masonry(galleryGrid, {
      itemSelector: '.js-masonry-gallery-item',
      columnWidth: 1,
      percentPosition: true,
      horizontalOrder: true,
      // gutter: 6,
    });
  });
}

/**
 * Posts and projects infinite scroll.
 */
// Posts loop intentionally keeps the default CSS grid (no Masonry outlayer).
var postsGrid = document.querySelector('.js-posts-loop');
var projectsGrid = document.querySelector('.js-projects-loop');
var paginationLink = document.querySelector('.js-infinite-scroll-pagination a');
var infiniteScrollOptions = {
  path: '.js-infinite-scroll-pagination a', // selector for the NEXT link (to page 2)
  button: '.js-infinite-scroll-pagination a', // next page button
  status: '.js-infinite-scroll-status', // wrapper for loading status msg and imgs
  history: false, // do not change browser history
  loadOnScroll: false, // disable loading on scroll
  scrollThreshold: false, // disable loading on scroll
};

/**
 * Get URL for next infinite scroll page.
 */
function getNextURL(doc) {
  return doc
    .querySelector('.js-infinite-scroll-pagination a')
    .getAttribute('href');
}

if (paginationLink) {
  // Initialize Infinite Scroll for posts
  if (postsGrid) {
    var infScroll = new InfiniteScroll(
      postsGrid,
      jQuery.extend(
        {
          append: '.js-loop-post', // selector for all items you'll retrieve
          // Home posts intentionally use the default CSS grid without Masonry.
          // Keep append-based loading so infinite scroll behavior is unchanged.
        },
        infiniteScrollOptions,
      ),
    );

    // Load infinity scroll content via button click
    paginationLink.addEventListener('click', function () {
      // load next page
      infScroll.loadNextPage();
      // hide button
      paginationLink.style.display = 'none';
    });

    // Update next page link after new posts are appended
    infScroll.on('append', function (response, path, newElements) {
      // update nextURL on page load
      var nextURL = getNextURL(response);
      // check if not last page (url is undefined) and update next page link
      if (nextURL !== undefined) {
        paginationLink.setAttribute('href', nextURL);
        // show button
        paginationLink.style.display = 'inline-block';
      }
    });
  }

  // Initialize Infinite Scroll for projects
  if (projectsGrid) {
    var infScrollProjects = new InfiniteScroll(
      projectsGrid,
      jQuery.extend(
        {
          append: '.js-loop-project', // selector for all items you'll retrieve
        },
        infiniteScrollOptions,
      ),
    );

    // Load infinity scroll content via button click
    paginationLink.addEventListener('click', function () {
      // load next page
      infScrollProjects.loadNextPage();
      // hide button
      jQuery(this).hide();
    });

    // Update next page link
    infScrollProjects.on('append', function (response, path, newElements) {
      // update nextURL on page load
      var nextURL = getNextURL(response);
      // check if not last page (url is undefined) and update next page link
      if (nextURL !== undefined) {
        paginationLink.setAttribute('href', nextURL);
        // show button
        paginationLink.style.display = 'inline-block';
      }
    });

    // Remove faded effect on last page
    infScrollProjects.on('last', function (response, path) {
      var fadeElem = document.querySelector('.projects-loop-list-fade-out');
      fadeElem.parentNode.removeChild(fadeElem);
    });
  }
}
